import { DialogDeleteComponent } from './delete.dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Directive, HostListener, EventEmitter, Output, Input, inject } from '@angular/core';

@Directive({
    selector: '[appDeleteClick]',
    standalone: true
})
export class DeleteClickDirective {
  @Output('appDeleteClick') appDeleteClick: EventEmitter<Event> = new EventEmitter<Event>();
  @Input('appDeleteTitle') appDeleteTitle: string = undefined;
  @Input('appDeleteText') appDeleteText: string = undefined;
  @Input('disabled') disabled: boolean;

  private dialog = inject(MatDialog);

  @HostListener('click', ['$event']) onClick(event: Event) {
    event.stopPropagation();
    if (this.disabled == true) {
      return false;
    }
    this.dialog.open(DialogDeleteComponent, {
      data: {
        text: this.appDeleteText,
        title: this.appDeleteTitle,
        onDelete: () => {
          this.appDeleteClick.emit(event);
        },
        onCancel: () => {

        }
      }
    });
  }

  constructor() {

  }

  ngOnInit(): void {
  }

}
